import React from 'react';
import styled from 'styled-components';
import { IconArrow } from './icons/Icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Button = styled.button.withConfig({
  displayName: "BackButton__Button",
  componentId: "sc-d6g0au-0"
})(["display:flex;align-items:center;justify-content:center;width:100%;height:48px;border:0;border-radius:4px;padding:0 12px;background-color:var(--wcds-colors-white);backdrop-filter:blur(2px);color:var(--wcds-colors-indigo-90);font-family:var(--wcds-font-secondary);font-size:20px;cursor:pointer;"]);
var ButtonText = styled.span.withConfig({
  displayName: "BackButton__ButtonText",
  componentId: "sc-d6g0au-1"
})(["margin-left:10px;"]);
var BackButtonContainer = styled.span.withConfig({
  displayName: "BackButton__BackButtonContainer",
  componentId: "sc-d6g0au-2"
})(["position:absolute;top:8px;left:8px;z-index:1000;opacity:", ";transition:opacity 0.1s linear;pointer-events:", ";&:hover{", "{color:var(--wcds-colors-blue-70);}svg path{fill:var(--wcds-colors-blue-70);}}&:focus-visible{box-shadow:inset 0 0 0 2 var(--wcds-colors-blue-70);}"], function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible ? 1 : 0;
}, function (_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible ? 'auto' : 'none';
}, Button);
export var BackButton = function BackButton(_ref3) {
  var isVisible = _ref3.isVisible,
      onClick = _ref3.onClick;
  return /*#__PURE__*/_jsx(BackButtonContainer, {
    onClick: onClick,
    isVisible: isVisible,
    children: /*#__PURE__*/_jsxs(Button, {
      children: [/*#__PURE__*/_jsx(IconArrow, {}), /*#__PURE__*/_jsx(ButtonText, {
        children: "Go back"
      })]
    })
  });
};